import { supabase } from "./supabase";

export type GlobalColorTheme = "sunny" | "sabah";
export type GlobalLanguage = "en" | "ms" | "sabah" | "zh";

const allLanguages: GlobalLanguage[] = ["en", "ms", "sabah", "zh"];

function normalizeLanguages(value: unknown): GlobalLanguage[] {
  if (!Array.isArray(value)) return [...allLanguages];
  const languages = allLanguages.filter((language) => value.includes(language));
  return languages.length ? languages : [...allLanguages];
}

export async function readGlobalColorTheme(): Promise<GlobalColorTheme> {
  const { data, error } = await supabase.from("site_appearance").select("color_theme").eq("id", "global").single();
  if (error) throw error;
  return data.color_theme === "sabah" ? "sabah" : "sunny";
}

export async function writeGlobalColorTheme(colorTheme: GlobalColorTheme): Promise<GlobalColorTheme> {
  const { data, error } = await supabase
    .from("site_appearance")
    .update({ color_theme: colorTheme, updated_by: (await supabase.auth.getUser()).data.user?.id ?? null })
    .eq("id", "global")
    .select("color_theme")
    .single();
  if (error) throw error;
  return data.color_theme === "sabah" ? "sabah" : "sunny";
}

export async function readGlobalEnabledLanguages(): Promise<GlobalLanguage[]> {
  const { data, error } = await supabase.from("site_appearance").select("enabled_languages").eq("id", "global").single();
  if (error) throw error;
  return normalizeLanguages(data.enabled_languages);
}

export async function writeGlobalEnabledLanguages(languages: GlobalLanguage[]): Promise<GlobalLanguage[]> {
  const normalized = normalizeLanguages(languages);
  const { data, error } = await supabase
    .from("site_appearance")
    .update({ enabled_languages: normalized, updated_by: (await supabase.auth.getUser()).data.user?.id ?? null })
    .eq("id", "global")
    .select("enabled_languages")
    .single();
  if (error) throw error;
  return normalizeLanguages(data.enabled_languages);
}
